import type { ReactNode } from 'react'

import { AppLoadError } from '@/components/AppLoadError'
import { PageSpinner } from '@/components/ui/PageSpinner'
import { useAuthStatus } from '@/models/auth'
import { SignInMode, SignInPanel } from './SignInPanel'

/** Shows its children to a signed-in browser, and the sign-in panel to anyone else. */
export function SignInGate({
  mode,
  loadingLabel,
  withoutAccount,
  children,
}: {
  mode?: SignInMode
  /** What the splash announces while the sign-in check runs. */
  loadingLabel?: string
  /** Shown instead of the sign-in panel to a browser signed in to another Cai product. */
  withoutAccount?: ReactNode
  children: ReactNode
}) {
  const { data: authStatus, error, refetch, isRefetching } = useAuthStatus()

  if (!authStatus) {
    return error ? (
      <AppLoadError error={error} onRetry={() => void refetch()} retrying={isRefetching} />
    ) : (
      <PageSpinner label={loadingLabel} />
    )
  }

  if (!authStatus.authenticated) {
    if (withoutAccount) return withoutAccount
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <SignInPanel mode={mode} />
      </div>
    )
  }

  return children
}
